import { TableFieldModel } from '@/model/TableList'

export const TableField: TableFieldModel[] = [
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'name',
    fieldName: '客户公司'
  }, {
    componentType: 'el-select',
    componentName: '下拉选择',
    fieldKey: 'salesMan',
    fieldName: '业务员'
  }, {
    componentType: 'el-select',
    componentName: '输入框',
    fieldKey: 'customerLevel',
    fieldName: '客户级别'
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'lastBusinessNo',
    fieldName: '末次业务'
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'lastBusinessTime',
    fieldName: '末次业务'
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'lastContactTime',
    fieldName: '末次联系'
  }
]
